import React, { useEffect, useState } from "react";
import classes from "./UserInfo.module.scss";

type UserInfoProps = {
  userName?: string;
  userEmail?: string;
};

const UserInfo = (props: UserInfoProps) => {
  return (
    <>
      <div className={classes.userInfo}>
        <div className={classes.userItem}>
          <div>{props.userName}</div>
          <div>{props.userEmail}</div>
        </div>
      </div>
    </>
  );
};

export default UserInfo;
